import s from '../allservices.jsx'
import { toast } from 'react-toastify';
export function CustomerList(actionCallback) {
    let accountId = localStorage.getItem('accountId')

    fetch(s.get_customerList + "/" + accountId, {
        headers: new Headers({
            'Content-Type': 'application/json',
          
        })
    })
        .then(response => {
            if (response.status === 200) {
                response.json().then(json => actionCallback(json, "success"))
            }
            else if (response.status === 401) {
                    actionCallback("401", "sessionout")
                    this.props.history.push('/SessionOut')
            }
            else {
                toast.error(response.headers.get('message'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });  
                actionCallback("no body", "error")
            }
        })
}


// WEBPACK FOOTER //
// ./src/services/components/customerlist.js